/* --slider-- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sustainability__slider').forEach((sliderWrap) => {
    const swiperElement = sliderWrap.querySelector('.swiper'); 
    const paginationElement = sliderWrap.querySelector('.swiper-pagination'); 
    const nextButton = sliderWrap.querySelector('.swiper-button-next'); 
    const prevButton = sliderWrap.querySelector('.swiper-button-prev'); 

    new Swiper(swiperElement, {
      loop: true,
      autoplay: {
        delay: 8000,
      },
      speed: 800,
      pagination: {
        el: paginationElement,
        clickable: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  });
});

/* --story-- */
document.querySelector('.sustainability__link-toggle').addEventListener('click', function () {
  document.querySelector('.sustainability__story-text').classList.toggle('show');
  document.querySelector('.sustainability__story-link').style.display = 'none';
  document.querySelector('.sustainability__story').classList.toggle('sp_show');
});

document.querySelector('.sustainability__close-btn').addEventListener('click', function () {
  document.querySelector('.sustainability__story-text').classList.remove('show');
  document.querySelector('.sustainability__story-link').style.display = 'block';
  document.querySelector('.sustainability__story').classList.remove('sp_show');
});
